import { readInstitution } from 'hooks/useInstitution'

// Only endpoints which own institution-scoped data receive this query.
const SCOPED_PATHS = /(?:^|\/)(?:faculties|directions|direction|groups|students|students-filter|syllabuses|syllabus|syllabus-builder|plan-templates|academic|academcalendar|dorm|accounting|dpo|postgrad|career|student-life|archive|library|funds(?:-[^/]*)?)(?:\/|$)|admin-panel\/(?:dashboard|search|reports|drilldown)|conversion\/work-requests/

export function attachInstitutionScope(instance) {
  instance.interceptors.request.use((config) => {
    if (SCOPED_PATHS.test(config.url || '')) {
      config.params = { institution: readInstitution(), ...config.params }
    }
    return config
  })
}
